import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#4C657B"
}
function SkiMor039({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M13.1 6.4q6.55-.05 13.15-.9-13 1.4-13.15-5.5Q12.45 6.85 0 5.5q6.55.85 13.1.9z"
                    id="SkiMor039__Symbol_50_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#SkiMor039__Symbol_50_0_Layer0_0_FILL"
                transform="translate(179.4 243.25)"
                id="SkiMor039__col1n"
            />
        </g></g>
    )
}
export default SkiMor039
